import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FindMoneyIntroComponent } from './find-money-intro/find-money-intro.component';
import { RouterModule, Routes } from '@angular/router';
import { BrightsideUiModule } from '@brightside/brightside-ui';
import { SharedDesktopModule } from '@brightside-web/shared/desktop';
import { MicroUiMoleculeModule } from '@micro-ui/molecule';
import { TranslateModule } from '@ngx-translate/core';
import { FindMoneyViewComponent } from './find-money-view/find-money-view.component';
import { FindMoneyPartnerIntroViewComponent } from './find-money-partner-intro-view/find-money-partner-intro-view.component';

const routes: Routes = [
  {
    path: 'intro',
    redirectTo: 'view',
  },
  {
    path: 'view',
    component: FindMoneyViewComponent,
  },
  {
    path: ':partnerKey',
    component: FindMoneyPartnerIntroViewComponent,
  },
  {
    path: 'intro/:partnerKey',
    component: FindMoneyPartnerIntroViewComponent,
  },
  {
    path: '**',
    redirectTo: 'intro',
  },
];

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    BrightsideUiModule,
    MicroUiMoleculeModule,
    SharedDesktopModule,
    TranslateModule,
  ],
  declarations: [FindMoneyIntroComponent, FindMoneyViewComponent, FindMoneyPartnerIntroViewComponent],
  providers: [],
})
export class DesktopFeatureFindMoneyModule {}
